(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-individual.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details-individual.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StepIndicatorResult = svs.components.marketplaceShared.stepIndicator.StepIndicatorResult;
const emptyDraw = {
  hasPlayed: false,
  isContributing: false,
  correctCount: 0
};
const CompetitionDetailsIndividual = _ref => {
  let _ref$drawResults = _ref.drawResults,
    drawResults = _ref$drawResults === void 0 ? [] : _ref$drawResults,
    _ref$numberOfDraws = _ref.numberOfDraws,
    numberOfDraws = _ref$numberOfDraws === void 0 ? 6 : _ref$numberOfDraws;
  const allDraws = [];
  for (let i = 0; i < Math.max(numberOfDraws, drawResults.length); i++) {
    allDraws.push(drawResults[i] ? drawResults[i] : _objectSpread(_objectSpread({}, emptyDraw), {}, {
      drawNumber: i
    }));
  }
  const _getLabels = list => list.map((_, index) => ({
    label: "Omg. ".concat(index + 1),
    ariaLabel: "Omg\xE5ng ".concat(index + 1)
  }));
  return React.createElement("div", {
    className: "competition-details-individual"
  }, React.createElement(StepIndicatorResult, {
    drawResults: allDraws,
    hasUnits: true,
    labels: _getLabels(allDraws)
  }));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.details.CompetitionDetailsIndividual', CompetitionDetailsIndividual);

 })(window);